import { useEffect } from '@wordpress/element';
import { useBlockProps } from '@wordpress/block-editor';
import Inspector from './InspectorControls';
import ShapeSvg from './shape-svg';
import { getWrapperClasses, getWrapperStyles } from './styles';
import './style.scss';

export default function Edit({ attributes, setAttributes, clientId }) {
  const blockProps = useBlockProps({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  /*
   * A gradient is a real <linearGradient> with a document-wide id, so two
   * dividers on one page would otherwise both resolve to whichever definition
   * rendered last. The id is stored rather than derived from clientId at save
   * time, because save() must produce identical markup on every load and
   * clientId does not survive a reload. Duplicating a block copies its id, so
   * a fresh one is issued whenever the stored id is not this instance's own.
   */
  useEffect(() => {
    const own = clientId.slice(0, 8);
    if (attributes.uniqueId !== own) {
      setAttributes({ uniqueId: own });
    }
  }, [clientId, attributes.uniqueId, setAttributes]);

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />
      <div {...blockProps}>
        <ShapeSvg attributes={attributes} />
      </div>
    </>
  );
}
